import Component from "@bythepixel/component-loader";

export default class Form extends Component {
  static selector = "[data-comp-form]";

  constructor(containerEl) {
    super(containerEl);

    // Required inputs
    this.requiredInputs = this.$container.querySelectorAll("[required]");
    this.requiredInputsAreFilled = false;

    // Container that shows the error/success
    this.formMessageContainer = this.$container.querySelector(
      "[data-comp-form-message]"
    );

    // This class is removed from the button on successful submissions
    this.buttonHideIconClass = "submit-button-hide-icon";
    this.button = this.$container.querySelector("[data-button]");

    // The button text is updated while the form is sending or if a submission has failed
    this.buttonText = this.$container.querySelector("[data-button-text]");
    this.initialButtonText = this.buttonText.innerText;
    this.initForm();
    this.inputFieldListener();
  }

  changeButtonText(text) {
    this.buttonText.innerText = text;
  }

  clearMessageContainer() {
    if (this.formMessageContainer && this.formMessageContainer.firstChild) {
      this.formMessageContainer.removeChild(
        this.formMessageContainer.firstChild
      );
    }
  }

  handleButtonEventsOnSuccess() {
    if (this.button.classList.contains(this.buttonHideIconClass)) {
      this.button.classList.remove(this.buttonHideIconClass);
    }

    this.changeButtonText("Sent");

    setTimeout(() => {
      this.button.classList.add(this.buttonHideIconClass);
      this.clearMessageContainer();
      this.changeButtonText(this.initialButtonText);
    }, 2000);
  }

  handleInputListenerEvents() {
    const filledInputs = [];
    for (let i = 0; i < this.requiredInputs.length; i += 1) {
      const input = this.requiredInputs[i];

      if (input.value !== "") {
        filledInputs.push(input);
      }
    }

    this.requiredInputsAreFilled =
      filledInputs.length === this.requiredInputs.length;
    if (this.requiredInputsAreFilled) {
      this.button.classList.add("button-primary");
      this.button.classList.remove("button-inactive");
    } else {
      this.button.classList.add("button-inactive");
      this.button.classList.remove("button-primary");
    }
  }

  initForm() {
    this.handleInputListenerEvents();
    this.$container.addEventListener("submit", (e) => this.submitForm(e));
  }

  inputFieldListener() {
    this.$container.addEventListener("input", () => {
      this.handleInputListenerEvents();
    });
  }

  showServerSuccessMsg() {
    renderMessage(
      this.formMessageContainer,
      "Thanks! We have received your contact submission."
    );

    this.handleButtonEventsOnSuccess();
  }

  showServerErrorMsg() {
    renderMessage(
      this.formMessageContainer,
      "<strong>Error!</strong> Something went wrong. Please try again later while we check this out."
    );
    this.changeButtonText("Submission Failed");
  }

  showServerPendingMsg() {
    this.changeButtonText("Sending...");
  }

  async submitForm(e) {
    e.preventDefault();
    this.appendSecureInput();
    this.disableForm();

    const formData = new FormData(e.target);

    this.showServerPendingMsg();
    const resp = await fetch("/api/form/send", {
      method: "post",
      body: formData,
    });

    await this.handleServerResponse(await resp);
    this.enableForm(await resp);
  }

  async handleServerResponse(resp) {
    const data = await resp.json();
    if (resp.status === 200) {
      this.showServerSuccessMsg();
    } else {
      this.showServerErrorMsg(data);
    }
    return data;
  }

  disableForm() {
    this.$container.querySelector('button[type="submit"]').disabled = true;
  }

  enableForm(resp) {
    // Enables the form again once we get a response back from the server
    if (resp) {
      this.$container.querySelector('button[type="submit"]').disabled = false;
    }
  }

  appendSecureInput() {
    if (document.getElementById(`${this.$id}_secureInput`)) return;
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "secure";
    input.value = "secure";
    input.id = `${this.$id}_secureInput`;
    this.$container.appendChild(input);
  }
}

function renderMessage(container, err) {
  container.insertAdjacentHTML("beforeend", getMessageHTML(err));
}

function getMessageHTML(message) {
  return `<p class="space-top--medium">${message}</p>`;
}
